<template>
	
	<div class="add-to-favorite">
		<div class="add-to-favorite__btn" v-if="!processing">
			<button class="add_to_favorite_button" v-if="!removeOnly || isFavorite"
				:class="{'is-active': isFavorite}"
				type="button"
				:title=title
				v-on:click="toggleFavorite()">
				<span v-if="isFavorite && !removeOnly" class="fa fa-heart"></span>
				<span v-if="isFavorite && removeOnly" class="fa-heart-xmark">
					<img class="fa-heart-xmark"/>
				</span>
				<span v-if="!isFavorite && article.isActive" class="fa-empty-heart">
					<img class="fa-empty-heart"/>
				</span>
			</button>
			<span v-if="!removeOnly">{{ article.reference }}</span>
		</div>
		<div class="add-to-favorite__spinner" v-if="processing">
			<Spinner></Spinner>
		</div>

	</div>

</template>

<script>
import Vue from 'vue';
import { actions } from '@/store/articles'
import api from '@/api/proxyWeb/me'
import Spinner from '@/components/spinner/Spinner.vue'

export const TOGGLE_FAVORITE_EVENT = 'addtofavorite'

export const FavoriteBus = new Vue();

export default {

	data: function() {
		return {
			processing: false
		}
	},

	props: {
		article: Object,
		variation: Object,
		removeOnly: {
			type: Boolean,
			default: false
		}
	},

	computed: {

		css: function () {
			return ''
		},

		disabled: function () {
			return this.processing
		},
		
		isFavorite: function () {
			return this.variation.isFavorite
		},

		title: function () {
			if ( this.variation.isFavorite ) {
				return "Retirer des favoris";
			}
			return "Ajouter aux favoris";
		}
		

	},

	methods: {

		toggleFavorite: function() {

			this.processing = true

			if ( this.variation.isFavorite ) {
				api.deleteFavorite(this.variation.postId)
				.then( () => {
						this.$notify.success(this.article.title + " retiré des favoris")
						this.$emit(TOGGLE_FAVORITE_EVENT, {})
						FavoriteBus.$emit(TOGGLE_FAVORITE_EVENT, {})
						this.variation.isFavorite = false
						this.$store.dispatch(actions.REMOVE_FAVORITE, this.variation)
					})
					.catch( () => {
						this.$notify.error("Impossible de retirer " + this.article.title + " des favoris")
						this.variation.isFavorite = true
					} )
					.finally( () => this.processing = false )
			}
			else {
				api.putFavorite(this.variation.postId)
				.then( () => {
						this.$notify.success(this.article.title + " ajouté aux favoris")
						this.$emit(TOGGLE_FAVORITE_EVENT, {})
						FavoriteBus.$emit(TOGGLE_FAVORITE_EVENT, {})
						this.variation.isFavorite = true
					})
					.catch( () => {
						this.$notify.error("Impossible d'ajouter " + this.article.title + " aux favoris")
						this.variation.isFavorite = false
					} )
					.finally( () => this.processing = false )
			}

		}
	},

	components: {
		Spinner
	}
}
</script>

<style scoped>

.add-to-favorite {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.add-to-favorite .add-to-favorite__btn button,
.add-to-favorite .add-to-favorite__btn .button {
	margin: 0 !important;
	min-width: 3.5rem;
	width: 3.5rem;
	cursor: pointer; 
	border: none; 
	background-color: transparent; 
}

.add-to-favorite .add-to-favorite__spinner {
	position: relative;
	overflow: hidden;
	height: 3rem;
	width: 3.5rem;
}

.add-to-favorite .add-to-favorite__spinner .spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(.26);
}

.add_to_favorite_button.is-active {
	color: rgb(5, 176, 144) !important;
}

.add_to_favorite_button.is-active:hover {
	color: rgb(5, 201, 165) !important;
}

.fa-empty-heart {
	height: 1em;
	fill: black;
	content:url(fa-empty-heart.svg);
}

.fa-heart-xmark {
	height: 1.5em;
	fill: black;
	filter: contrast(30%);
	content:url(fa-heart-circle-xmark-solid.svg);
}

</style>